// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__zMUG3","row":"styles_row__36s-e"};